import { render, staticRenderFns } from "./ReportCtsCartas.vue?vue&type=template&id=4249a8bf&scoped=true&"
import script from "./ReportCtsCartas.vue?vue&type=script&lang=js&"
export * from "./ReportCtsCartas.vue?vue&type=script&lang=js&"
import style0 from "./ReportCtsCartas.vue?vue&type=style&index=0&id=4249a8bf&lang=scss&scoped=true&"
import style1 from "./ReportCtsCartas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249a8bf",
  null
  
)

export default component.exports